import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';

import { SharedModule } from '../../shared.module';
import { ShellComponent } from './shell.component';

@NgModule({
  declarations: [ShellComponent],
  imports: [
    SharedModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatDividerModule,
  ],
  exports: [ShellComponent],
})
export class ShellModule {}
